// src/pages/ConfirmEmail.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost/securecontrol-backend";

const ConfirmEmail = () => {
  const location = useLocation();

  useEffect(() => {
    // auth/confirm-email.php renvoie directement une page HTML complète (pas
    // du JSON) : on redirige le navigateur dessus plutôt que de faire un
    // appel axios. L'ancienne version se contentait de remplacer ":3000"
    // dans l'URL courante — un no-op en production (aucun ":3000" dans
    // l'URL), qui rechargeait la page sans jamais atteindre le backend.
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    window.location.href = `${API_BASE_URL}/auth/confirm-email.php?token=${encodeURIComponent(token || "")}`;
  }, [location]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <p>Redirection vers la confirmation email...</p>
    </div>
  );
};

export default ConfirmEmail;